// MessageCustomDateSeparator.js
import React from 'react';
import DaysAgo from './DaysAgo';
const MessageCustomDateSeparator = ({ date }) => {
    return (<div style={{ textAlign: 'center', margin: '10px 0', color: '#888' }}>
        <DaysAgo date={date} isseprator={true}></DaysAgo>    </div>
    );
};
export default MessageCustomDateSeparator;
